<template>
	<div class="container">
		<div class="cancel">
			<p>请选择取消预约理由</p>
			<div v-for="(item,index) in cancel">
				<div>{{item.name}}</div>
				<img v-if="item.show" src="../assets/cancel_red.png" @click="cancel_cli(item,index)" />
				<img v-else="" src="../assets/cancel_white.png" @click="cancel_cli(item,index)" />
			</div>
		</div>
		<div class="file_container">
			<textarea class="file_text" name="file_text" rows="" maxlength="150" cols="" placeholder="请输入取消预约的详细理由（选填）"></textarea>
		</div>
		<div class="file_btn" @click="Submission" v-show="showBtn">提交</div>
		<div class="appointment_success" v-show="success">
			<div class="success_center">
				<img v-if="success_img" src="../assets/success.png" />
				<img v-if="!success_img" src="../assets/buttom_x.png" />
				<p>{{success_text}}</p>
				<div @click="determine">确定</div>
			</div>
		</div>
	</div>
</template>

<script>
	import { wclient } from '../../static/wclient-mobile.js'
	export default {
		name: 'CancelReservation',
		data() {
			return {
				cancel: [{
					"name": "1.报名信息填错了，重新购买",
					"show": false
				}, {
					"name": "2.计划有变，没时间参加",
					"show": false
				}, {
					"name": "3.没什么，就是不想参加了",
					"show": false
				}],
				activeClass: -1,
				orderid: "",
				baseUrl: "",
				reason: "",
				success: false,
				success_img: false,
				success_text: "",
				tcid: "",
				clientHeight: document.documentElement.clientHeight,
				showBtn: true
			}
		},
		methods: {
			cancel_cli(item, index) {
				var that = this;
				that.cancel.forEach(i => {
					if(i.show !== that.cancel[index].show) {
						i.show = false;
					}
				});
				item.show = !item.show;
				that.reason = item.name;
			},
			Submission() {
				var that = this;
				if(that.reason == '') {
					that.success = true;
					that.success_img = false;
					that.success_text = '请选择取消理由'
				} else {
					wclient.view.showLoading();
					wclient.crossdomain = true; // 启动跨域支持（多模块组合应用）
					if(that.tcid != null) {
						wclient.ajax({
							type: "GET",
							url: that.baseUrl + '/tickets/tickets/ajax?ugi=bookingticketorder&action=cancelticketcode&moduleid=TICKETS&tcid=' + that.tcid,
							dataType: "json",
							async: true,
							data: {
								reason: that.reason,
								remarks: ""
							},
							success: function(data) {
								if(data.code == 'A00006') {
									wclient.view.hideLoading();
									that.success = true;
									that.success_img = true;
									that.success_text = '预约已取消'
								} else {
									wclient.view.hideLoading();
									that.success = true;
									that.success_img = false;
									that.success_text = data.errmsg;
								}
							}
						});
					} else {
						wclient.ajax({
							type: "GET",
							url: that.baseUrl + '/tickets/tickets/ajax?ugi=bookingticketorder&action=cancelBooking&moduleid=TICKETS&orderid=' + that.orderid,
							dataType: "json",
							async: true,
							data: {
								reason: that.reason,
								remarks: ""
							},
							success: function(data) {
								if(data.code == 'A00006') {
									wclient.view.hideLoading();
									that.success = true;
									that.success_img = true;
									that.success_text = '预约已取消'
								} else {
									wclient.view.hideLoading();
									that.success = true;
									that.success_img = false;
									that.success_text = data.errmsg;
								}
							}
						});
					}
				}
			},
			determine() {
				var that = this;
				if(that.success_text == "预约已取消") {
					that.$router.go(-1)
					sessionStorage.removeItem('tcid')
				} else {
					that.success = false;
				}
			}
		},
		mounted() {
			var that = this;
			var publicUrl = window.location.hostname;
			if(publicUrl == "localhost") {
				 var baseUrl = "https://www.xiangshan1949.cn/ajax";
			} else if(publicUrl == "m.xs.weapi.org") {
				var baseUrl = "https://www.xiangshan1949.cn";
			} else {
				var baseUrl = "https://www.xiangshan1949.cn";
			}
			that.baseUrl = baseUrl;
			that.orderid = sessionStorage.getItem("cancel_orderid");
			that.tcid = sessionStorage.getItem("tcid");
			window.onresize = () => {
				if(this.clientHeight > document.documentElement.clientHeight) {
					this.showBtn = false
				} else {
					this.showBtn = true
				}

			}
		}
	}
</script>

<style scoped>
	.container {
		width: 100%;
		-webkit-overflow-scrolling: touch;
	}
	
	.cancel {
		width: 88%;
		margin: 3%;
		background: rgba(246, 246, 246, 1);
		padding: 20px 3%;
	}
	
	.cancel p {
		width: 100%;
		font-size: 16px;
		font-weight: bold;
		color: rgba(48, 48, 48, 1);
	}
	
	.cancel>div {
		display: flex;
		justify-content: space-between;
		line-height: 60px;
		align-items: center;
		border-bottom: 1px solid rgba(222, 218, 218, 1);
		font-weight: 400;
		color: rgba(48, 48, 48, 1);
	}
	
	.cancel>div:last-child {
		border-bottom: none;
	}
	
	.cancel img {
		width: 4%;
		margin-right: 2%;
	}
	
	.file_container {
		width: 100%;
		float: left;
		position: relative;
	}
	
	.file_text {
		display: block;
		width: 84%;
		height: 160px;
		margin: 3%;
		background: rgba(246, 246, 246, 1);
		outline: none;
		padding: 4% 5%;
		font-size: 14px;
		overflow: hidden;
		border: none;
		resize: none;
	}
	
	.file_btn {
		width: 70%;
		line-height: 45px;
		background: rgba(215, 43, 39, 1);
		border-radius: 62px;
		position: fixed;
		bottom: 30px;
		left: 15%;
		text-align: center;
		font-size: 16px;
		color: rgba(254, 254, 254, 1);
	}
	
	.appointment_success {
		width: 110%;
		height: 100%;
		background: rgba(0, 0, 0, 0.54);
		position: fixed;
		top: 0;
		left: 0;
	}
	
	.success_center {
		margin-top: 35%;
		background: white;
		width: 60%;
		margin-left: 15%;
		padding-top: 10px;
		border-radius: 10px;
	}
	
	.success_center img {
		width: 25%;
		margin-left: 37%;
		margin-top: 30px;
	}
	
	.success_center p:nth-of-type(1) {
		width: 100%;
		color: black;
		font-size: 20px;
		font-weight: 600;
		text-align: center;
		margin-top: 20px;
	}
	
	.success_center p:nth-of-type(2) {
		width: 100%;
		color: #A4A4A4;
		font-size: 16px;
		text-align: center;
		margin-top: 5px;
		letter-spacing: 1px;
	}
	
	.success_center div {
		width: 100%;
		line-height: 45px;
		text-align: center;
		font-weight: 600;
		color: rgba(228, 4, 4, 1);
		border-top: 1px solid #eee;
		margin-top: 25px;
	}
</style>


// WEBPACK FOOTER //
// src/components/cancelReservation.vue